<template>
  <table>
    <thead>
      <tr>
        <th>{{$t('Incertidumbre')}}</th>
        <th>{{$t('Frecuencia')}}</th>
        <th>{{$t('Factor de Probabilidad')}}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-bind:key="i" v-for="(prob, i) in probabilidades">
        <td>
          {{ prob.uncertainty }}
        </td>
        <td @click="click(prob.likelihoodFactor)">
          {{ prob.projects }}
        </td>
        <td>
          {{ prob.likelihoodFactor }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'TablaProbabilidad',
  props: [
    'click',
  ],
  data() {
    return {
      probabilidades: [
        {
          uncertainty: this.$t('Altamente probable'),
          projects: this.$t('Es probable que ocurra dentro de un período de 1 año.'),
          likelihoodFactor: 3,
        },
        {
          uncertainty: this.$t('Probable'),
          projects: this.$t('Es probable que ocurra dentro de un periodo de 1 a 5 años.'),
          likelihoodFactor: 1,
        },
        {
          uncertainty: this.$t('Posible'),
          projects: this.$t('Es probable que ocurra dentro de un período de 5 a 20 años.'),
          likelihoodFactor: 0.3,
        },
        {
          uncertainty: this.$t('Improbable'),
          projects: this.$t('Es probable que ocurra dentro de un período de 20 a 50 años.'),
          likelihoodFactor: 0.1,
        },
        {
          uncertainty: this.$t('Altamente improbable'),
          projects: this.$t('No es probable que ocurra dentro de un período de 50 años.'),
          likelihoodFactor: 0.03,
        },
      ],
    };
  },
};
</script>

<style scoped>
  table {
    border-collapse: collapse;
  }
  thead {
    color: white;
  }
  thead tr:first-child {
    background-color: rgb(230, 84, 0);
  }
  thead tr:nth-child(2) {
    background-color: rgb(250, 182, 54);
  }
  td, th {
    padding: 10px;
    border: 1px solid #454545;
  }
  td:first-child, td:last-child {
    background-color: rgb(248, 214, 150);
    text-align: center;
    font-weight: bold;
  }
  td:nth-child(2), td:nth-child(3) {
    padding: 15px;
  }
  td:nth-child(2):hover, td:nth-child(3):hover {
    cursor: pointer;
    transition: 0.5s background-color;
    background-color: #ececec;
  }
</style>
